var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"has-text-weight-bold mt-4 text-base text-gray-500"},[_vm._v(" "+_vm._s(_vm.value.label)+" : ")]),_c('rating-stars',{attrs:{"value":_vm.value.value,"config":_vm.value.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }